import styled from 'styled-components';

import { Colors } from '@estee/elc-base-theme';

const { black } = Colors;

export const StyledButton = styled.button`
    padding: 0;
    margin: 0;
    text-align: left;
    height: unset;
    line-height: unset;
    font-size: 14px;
    width: fit-content;
    background: unset;
    border: unset;
    border-bottom: 1px solid ${black};
    &:disabled {
        cursor: not-allowed;
        opacity: 0.65;
    }
`;
